/**
 * Company: SPHMedia
 * Description: [Portrait video section component for displaying a carousel of portrait videos]
 */

import PortraitVideoCard from "@blocks/Card/PortraitVideoCard";
import CustomCarousel from "@blocks/CustomCarousel/CustomCarousel";
import usePortraitVideos from "@hooks/useBrightcoveVideos/usePortraitVideos";
import useWindowDimensions from "@src/app/hooks/useWindowDimensions";
import { ReactElement, useRef, useState } from "react";

import SectionHeadings from "./SectionHeadings";

/**
 * PortraitVideoSection
 * Description: [Portrait video section component for displaying a carousel of portrait videos]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function PortraitVideoSection(): ReactElement {
  const pipContainerRef = useRef<HTMLDivElement>(null);
  const parentRef = useRef<HTMLDivElement | null>(null);
  const [isMute, setIsMute] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const { playing, videos, handleOnClickThumbnail, handleOnEndedVideo } =
    usePortraitVideos({ parentRef });

  const { width } = useWindowDimensions();
  const isMobile = width < 540;
  const isTablet = width >= 540 && width < 1024;

  if (videos.length === 0) {
    return <></>;
  }

  const firstVideo = videos[0];

  return (
    <>
      <div
        ref={pipContainerRef}
        className={`fixed bottom-4 right-4 z-50
          ${isSticky ? "block w-[300px]" : "hidden"}`}
      />

      <div ref={parentRef} className="w-full">
        <CustomCarousel
          title={
            <SectionHeadings
              headingText="குற்றொளி"
              headingLink={`/quick-news/video/${firstVideo.id}?ref=tm_shorts`}
            />
          }
          slidesPerView={isMobile ? 1.2 : isTablet ? 2.5 : 3.2}
          showNavigation={!isMobile}
          draggable={isMobile}
        >
          {videos.map((video) => (
            <PortraitVideoCard
              key={video.id}
              video={video}
              isPlaying={playing?.id === video.id}
              parentRef={parentRef}
              pipContainerRef={pipContainerRef}
              handleOnEndedVideo={handleOnEndedVideo}
              handleOnClickThumbnail={handleOnClickThumbnail}
              isMute={isMute}
              setIsMute={setIsMute}
              isSticky={isSticky}
              setIsSticky={setIsSticky}
            />
          ))}
        </CustomCarousel>
      </div>
    </>
  );
}
